import DataviluazizationServices from '../../../../Services/DatavizualizationServices';
import SystemServices from '../../../../Services/SystemServices';
import { ApiResponseMinAndMaxDates } from '../../context/TypeDataviz';

export function DatavizBridgeCrud($rootScope,accountId,$timeout,$http) {
	const systemServices = new SystemServices($rootScope, $timeout);
	const datavizServices = new DataviluazizationServices(accountId, $http	);

	function getLimitAggregatedVisitorJourneyForAccount(callbackSuccess, callbackError) {
		datavizServices.getLimitAggregatedVisitorJourneyForAccount(
			(data: ApiResponseMinAndMaxDates[]) => {
				callbackSuccess(data);
			},
			(err: any, dataError: any) => {
				console.log('error', err);
				console.log('=>(dataError', dataError);
				if(dataError && dataError.status === 404){
					callbackError('No data for this account');
				}
				callbackError(err);
			}
		);
	}
	function getAggregatedVisitorJourney(DatavizualizationSettings,callbackSuccess, callbackError) {
		datavizServices.getAggregatedVisitorJourney(
			DatavizualizationSettings,
			(data: any) => {
				callbackSuccess(data);
			},
			(err: any, dataError: any) => {
				console.log('error', err);
				console.log('=>(dataError', dataError);
				systemServices.showError(dataError);
				callbackError(err);
			}
		);
	}
	
	function getTenantScore(callbackSuccess, callbackError) {
		datavizServices.getTenantScore(
			(data: any) => {	
				callbackSuccess(data);
			},
			(err: any, dataError: any) => {
				console.log('error', err);
				console.log('=>(dataError', dataError);
				systemServices.showError(dataError);
				callbackError(err);
			}
		);
	}

	return {
		getLimitAggregatedVisitorJourneyForAccount,
		getAggregatedVisitorJourney,
		getTenantScore
	};
}